//#region IMPORT
import React from 'react';
import { Box, Stack } from '@mui/material';
import M_FILE_CUSTOM_01F from '../M_FILE_CUSTOM_01/M_FILE_CUSTOM_01F';
import M_FILE_CUSTOM_02F from '../M_FILE_CUSTOM_02/M_FILE_CUSTOM_02F';
import M_FILE_CUSTOM_03F from '../M_FILE_CUSTOM_03/M_FILE_CUSTOM_03F';
//#endregion

function M_FILE_CUSTOM(props) {
  //#region 변수
  const components = [
    // 교육 자료
    <M_FILE_CUSTOM_01F userInfo={props.userInfo} />,
    // 작업계획서
    <M_FILE_CUSTOM_02F userInfo={props.userInfo} />,
    // 작업허가서
    <M_FILE_CUSTOM_03F userInfo={props.userInfo} />,
  ];
  //#endregion

  return (
    <Box sx={{ backgroundColor: '#F3F7F8', height: '100%' }}>
      <Stack sx={{ width: '100%', height: '100%' }}>
        {components[props.activeStep] || null}
      </Stack>
    </Box>
  );
}

export default M_FILE_CUSTOM;
